import { Provider } from 'react-redux';

import { filterProducts, filterInsulationEnclosureProducts } from './filterProducts';
import RoofingComponentFilter from './filters/RoofingComponentFilter';
import * as productItemComponents from './items';
import ProductList from '../OC/oc-filter-list';
import { store as STORE } from '../Store.jsx';
import { wallbuilderConnector } from '../wallbuilder/connector';

const ConnectedProductList = wallbuilderConnector(ProductList);

// Original implementation.
// Retained for cased where new translations are not present.
function fallbackProductCountDescription({ category, count, t }) {
  return `${count} ${t(`product_list.business.${category}`)} ${t('product_list.product')}${count === 1 ? '' : 's'}`;
}

function selectedProductsCountDescription({ category, count, t }) {
  let translation;
  switch (count) {
    case 0:
      translation = t(`product_list.zero_product_description.${category}`);
      break;
    case 1:
      translation = t(`product_list.single_product_description.${category}`, { count });
      break;
    default:
      translation = t(`product_list.multiple_product_description.${category}`, { count });
  }

  return translation || fallbackProductCountDescription({ category, count, t });
}

function selectedProductsCountFilterDescription({ category, count, t }) {
  const translation =
    count === 1
      ? t(`product_list.single_product_filter_description.${category}`, { count })
      : t(`product_list.multiple_product_filter_description.${category}`, { count });

  return translation || fallbackProductCountDescription({ category, count, t });
}

const pluralizationFunc = ({ category, mobile, count, t }) =>
  mobile
    ? selectedProductsCountFilterDescription({ category, count, t })
    : selectedProductsCountDescription({ category, count, t });

const ProductFilterWrapper = props => {
  const ItemComponent = productItemComponents[props.productComponent];
  return (
    <Provider store={STORE}>
      <section>
        <ConnectedProductList
          {...props}
          items={props.products}
          itemPluralizationFunc={({ mobile, count, t }) =>
            pluralizationFunc({ category: props.category, mobile, count, t })
          }
          className={props.category === 'insulation/enclosure' ? 'enclosure' : props.category}
          filterFunc={props.category === 'insulation/enclosure' ? filterInsulationEnclosureProducts : filterProducts}
          itemComponent={item => (
            <ItemComponent
              key={item.uid}
              product={item}
              product_path={props.product_path}
              genericImage={props.genericImage}
            />
          )}
          itemKeyFactory={i => i.uid}
          customFilterFactories={{
            RoofingComponentFilter: commonProps => <RoofingComponentFilter {...commonProps} />,
          }}
        />
      </section>
    </Provider>
  );
};

export default ProductFilterWrapper;
